import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHFeriadoGet = async (credentials, data) => {
  const body = {
    service: "RNHFeriadoGet",
    params: {
      rnhFeriadoId: data?.id || null,
      rnhFeriadoNombre: data?.nombre || null,
      rnhFeriadoTipo: data?.tipo || null
    },
  };
  return respuestaDe(await axiosPost(body, credentials));

};
